import React from 'react';
export var InfoCircleIcon = function InfoCircleIcon(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("rect", {
    x: "22",
    y: "18.5",
    width: "4",
    height: "20"
  }), React.createElement("rect", {
    x: "22",
    y: "10.5",
    width: "4",
    height: "4"
  }), React.createElement("path", {
    d: "M24,5.5c10.5,0,19,8.5,19,19s-8.5,19-19,19S5,35,5,24.5S13.5,5.5,24,5.5 M24,1.5c-12.7,0-23,10.3-23,23s10.3,23,23,23\n      s23-10.3,23-23S36.7,1.5,24,1.5L24,1.5z"
  }));
};